import React, { useEffect } from "react"
import { Provider } from 'mobx-react'
import axios from "axios";

import Stores from './Stores'
import Component from "./Components"
import config from "./config";

axios.defaults.baseURL = config.urlApi;

if( localStorage.getItem("token") ){
	axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("token")}`;
}

function App() {
		return (
			<Provider store={Stores} {...Stores}>
			<div className="app">
				<Component.Layout.Main/>
			</div>
		</Provider>
	);
}

export default App
